// Created by Michael Abadi Santoso
// 03 June 2020
// Copyright OKKAMI

///
/// Use this class for exposing the styling on product detail page
///

// TECHDEBT: Please move List and some common style into global instead
import styled from "styled-components";

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  margin: auto 0;
  padding: 10px 0 0;
`;

const ImageStyle = styled.img`
  width: 200px;
  height: 200px;
  border-color: "brown";
  border: ${(props) => props.border ? "5px solid brown" : "0px"};
  object-fit: cover;
`;

const ListTitle = styled.div`
  flex: 1;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
`;

const ListHeaderTitle = styled.div`
  color: ${(props) => props.app_home_list_item_title_color ? props.app_home_list_item_title_color : "black"};
  padding: 20px 20px 0 20px;
  font-size: 16px;
`;

const ListSubTitle = styled.pre`
  color: ${(props) => props.app_home_list_item_subtitle_color ? props.app_home_list_item_subtitle_color : "gray"};
  font-weight: normal;
  padding: 10px 20px;
  font-family: 'Open Sans','Montserrat',sans-serif;
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 14px;
`;

const TopPadding = styled.div`
  padding: 20px 0;
`;

const NameStyle = styled.div`
  margin-right: 10px;
  color: gray;
  font-size: 16px;
`;

const DateStyle = styled.div`
  margin: auto 0;
  font-weight: normal;
  font-size: 16px;
`;

const PairButton = styled.button`
  margin: 16px 0;
  border: 1px solid;
  padding: 5px 30px;
  border-radius: 15px;
  color: ${(props) => props.app_home_text_top_nav ? props.app_home_text_top_nav : 'white'};
  background: ${(props) => props.app_home_color_primary ? props.app_home_color_primary : "black"};
`

const CircleButton = styled.button`
  color: ${(props) => props.app_home_color_secondary ? props.app_home_color_secondary : "black"};
  display: flex;
  background-color: white;
  border-radius: 32px;
  border-style: solid;
  border-width: 1px;
  border-color: gray;
  width: 60%;
  height: auto;
  justify-content: space-between;
  align-items: center;
  margin: 16px;
  padding: 8px;
`;

const NumberStyle = styled.div`
  font-weight: normal;
  text-decoration: underline;
  font-size: 15px;
`;

const Container = styled.div`
  padding: 0 0 5rem 0;
`;

const SmallTitle = styled.div`
  margin: auto;
  text-align: center;
  color: ${(props) => props.app_home_text_top_nav ? props.app_home_text_top_nav : 'white'};
  font-size: 1.5rem;
`;

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  margin: auto;
  padding: 0 2rem;;
  justify-content: space-between;
  height: 5rem;
`;

const NavBarLink = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: ${(props) => props.app_home_color_primary ? props.app_home_color_primary : "black"};
  z-index: 1;
  font-size: 1.4rem;

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

const TitlePrice = styled.div`
  color: black;
  padding: 10px 20px 10px 20px;
  text-align: center;
  font-size: 16px;
`;

const TitleAlert = styled.div`
  color: ${(props) => props.app_home_list_item_subtitle_color ? props.app_home_list_item_subtitle_color : "red"};
  padding: 16px;
  text-align: center;
  font-size: 14px;
`;


export {
  Image, ListTitle, ListHeaderTitle, ListSubTitle, TopPadding, ImageStyle, NameStyle, DateStyle, CircleButton,
  NumberStyle, Container, SmallTitle, FlexContainer, NavBarLink, TitlePrice, TitleAlert, PairButton
};
